import { render } from "./DeleteDeviceModal.vue?vue&type=template&id=0a8c0490&scoped=true&ts=true"
import script from "./DeleteDeviceModal.vue?vue&type=script&lang=ts"
export * from "./DeleteDeviceModal.vue?vue&type=script&lang=ts"

import "./DeleteDeviceModal.vue?vue&type=style&index=0&id=0a8c0490&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a8c0490"]])

export default __exports__